import template from './screen.dot';
const screenTemplate = template.default ? template.default : template;
export { screenTemplate };
